import { AxiosResponse, InternalAxiosRequestConfig } from './types'
import { ElMessage, ElMessageBox } from 'element-plus'
import qs from 'qs'
import { SUCCESS_CODE, TRANSFORM_REQUEST_DATA } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { objToFormData } from '@/utils'
import { logWarning } from '@/utils/tracker'

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  if (
    config.method === 'post' &&
    config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data)
  } else if (
    TRANSFORM_REQUEST_DATA &&
    config.method === 'post' &&
    config.headers['Content-Type'] === 'multipart/form-data' &&
    !(config.data instanceof FormData)
  ) {
    config.data = objToFormData(config.data)
  }
  if (config.method === 'get' && config.params) {
    let url = config.url as string
    url += '?'
    const keys = Object.keys(config.params)
    for (const key of keys) {
      if (config.params[key] !== void 0 && config.params[key] !== null) {
        url += `${key}=${encodeURIComponent(config.params[key])}&`
      }
    }
    url = url.substring(0, url.length - 1)
    config.params = {}
    config.url = url
  }
  return config
}

/**
 * 业务异常统一上报（一处覆盖所有页面的所有接口）。
 * 只记 path/code/msg，**不记请求体**——里面可能有密码、验证码等敏感信息。
 */
const trackApiBusinessError = (response: AxiosResponse) => {
  const path = response?.config?.url ?? ''
  // 埋点自身依赖的接口不记，避免失败时自我循环
  if (path.includes('/log/sts_token')) return
  logWarning('api_business_error', {
    path,
    method: response?.config?.method ?? '',
    code: response.data?.code,
    msg: response.data?.msg ?? ''
  })
}

const defaultResponseInterceptors = (response: AxiosResponse) => {
  if (response?.config?.responseType === 'blob') {
    // 如果是文件流，直接过
    return response
  } else if (response.data?.code === SUCCESS_CODE) {
    return response.data
  }

  // 走到这里都是业务失败，统一记一条
  trackApiBusinessError(response)

  if (response.data?.code === 40100) {
    // 账号/会员已过期：跳转"联系客服续费"页（懒加载 router 避免循环依赖）
    import('@/router').then(({ default: router }) => {
      router.push('/trial-expired')
    })
  } else if (response.data?.code >= 20000) {
    // 需要弹窗确认的提示（code >= 20000），用 MessageBox 代替 toast
    ElMessageBox.alert(response?.data?.msg?.replace(/\n/g, '<br>') ?? '', '提示', {
      confirmButtonText: '我知道了',
      type: 'warning',
      dangerouslyUseHTMLString: true
    })
  } else if (response.data?.code > SUCCESS_CODE) {
    ElMessage.error(response?.data?.msg)
    if (response?.data?.code === 401) {
      const userStore = useUserStoreWithOut()
      userStore.logout()
    }
  }
}

export { defaultResponseInterceptors, defaultRequestInterceptors }
